<template>
    <div class="privacy-policy">
        <div class="px-4 py-5">
            <span v-html="$t(privacyPolicyTextKey, privacyPolicyDataObject)" />
        </div>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
import { fetchInteractionPrivacyPolicy } from '@/services/interaction'
import { mapActions } from 'vuex'
import { TEXT_TYPES } from '@/constants/i18n'
import { waitForAppReady } from '@/utils/waitForAppReady';


export default {
    name: 'PrivacyPolicy',
    props: {
        interactionInstanceToken: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            privacyPolicyData: null
        }
    },
    computed: {
        ...mapGetters([
            'interactionInstance',
        ]),
        productType() {
            return this.$route.query.product
        },
        privacyPolicyTextKey() {
            if(this.productType === 'BQ_ADVISORY_WEALTH' || this.productType === 'BQ_ADVISORY_BANK') {
                return 'INTERACTION_BASE_PRIVACY_POLICY_BQA'
            } else if(this.productType === 'BQ_SELECTION') {
                return 'INTERACTION_BASE_PRIVACY_POLICY_BQP'
            } else if(this.productType === 'BQ_PERFORMANCE_SELF_ASSESSMENT') {
                return 'INTERACTION_BASE_PRIVACY_POLICY_BQP_SELF_ASSESSMENT'
            } else {
                return 'INTERACTION_BASE_PRIVACY_POLICY_GENERIC'
            }
        },
        privacyPolicyDataObject() {
            const isSelfServiceTrial = this.interactionInstance?.organizationType === 'SELF_SERVICE'
                && this.interactionInstance?.productType ==='BQ_ADVISORY_WEALTH'
                && this.interactionInstance?.productLevel === 'TRIAL'
                && this.interactionInstance?.isTrialAvailable;
            const isBenchmarkSelfService = this.interactionInstance?.organizationType === 'SELF_SERVICE' 
                && this.interactionInstance?.productType ==='BQ_PERFORMANCE_SELF_ASSESSMENT'
                && this.interactionInstance?.productLevel === 'BASIC';

            if(isSelfServiceTrial ||isBenchmarkSelfService) {
                return {
                    organizationName: this.$t('INTERACTION_BASE_PRIVACY_POLICY_CONTROLLER_BQ_ORGANIZATION_NAME'),
                    organizationAddress: this.$t('INTERACTION_BASE_PRIVACY_POLICY_CONTROLLER_BQ_ORGANIZATION_ADDRESS'),
                    organizationEmail: this.$t('INTERACTION_BASE_PRIVACY_POLICY_CONTROLLER_BQ_ORGANIZATION_EMAIL'),
                };
            } else if(this.privacyPolicyData) {
                return {
                    organizationName: this.privacyPolicyData.name,
                    organizationAddress: this.privacyPolicyData.address,
                    organizationEmail: this.privacyPolicyData.email
                };
            }
            return undefined
        }
    },
    methods: {
        ...mapActions([
            'setLoadingUntilResolved',
            'fetchTranslations',
            'fetchInteractionInstance'
        ])
    },
    async mounted() {
        await waitForAppReady(this.$store);
        await this.fetchInteractionInstance({ interactionInstanceToken: this.interactionInstanceToken });
        await this.setLoadingUntilResolved([
            this.fetchTranslations({ textType: TEXT_TYPES.INTERACTION_BASE }),
            fetchInteractionPrivacyPolicy(this.interactionInstanceToken).then(privacyPolicyData => {
                this.privacyPolicyData = privacyPolicyData;
            }),
        ]);
    }
}
</script>
<style>
.privacy-policy {
    color: black;
}
</style>